import React from 'react';

const ProbabilityFocusChanger = ({probability_focus, changeProbabilityFocus, formatters}) => {

  const handleOnChange = (e) => {
    changeProbabilityFocus(e.target.value)  
  }

  return  (
    <div className="col-12 mt2">
      <div className="px2">
        Probability Focus: {formatters.percentFormat(probability_focus)}
      </div>
      <div className=""
        style={{background: 'linear-gradient(90deg, #d01c8b, #f7f7f7 50%, #4dac26)'}}
      >
        <input className="col-12" type="range" min="0" max="1" step="0.1" value={probability_focus} onChange={handleOnChange.bind(this)} />
      </div>
    </div>
  ) 
}

export default ProbabilityFocusChanger;


/** WEBPACK FOOTER **
 ** ./src/components/ProbabilityFocusChanger.js
 **/